var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6949 8.71929L7.4769 2.93729L13.2589 8.71929C13.4475 8.90145 13.7001 9.00224 13.9623 8.99996C14.2245 8.99768 14.4753 8.89252 14.6607 8.70711C14.8461 8.5217 14.9513 8.27089 14.9536 8.00869C14.9559 7.74649 14.8551 7.49389 14.6729 7.30529L8.1869 0.819287C8.09389 0.725885 7.9832 0.651957 7.86129 0.601821C7.73939 0.551685 7.60871 0.526347 7.4769 0.527287C7.34513 0.526625 7.21454 0.55209 7.09267 0.60221C6.9708 0.65233 6.86008 0.72611 6.7669 0.819287L0.280902 7.30529C0.0987434 7.49389 -0.0020504 7.74649 0.000227928 8.00869C0.00250626 8.27089 0.107674 8.5217 0.293082 8.70711C0.478491 8.89252 0.729303 8.99768 0.9915 8.99996C1.2537 9.00224 1.5063 8.90145 1.6949 8.71929Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.9b67be1f1cd64ddd26cfbe30fe295427.svg";
export { ForwardRef as ReactComponent };